import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { List } from 'immutable';
import { Observable } from 'rxjs/Observable';
import { AuthHttp } from 'angular2-jwt';
import { Attachment } from '../../models/attachment';
import { ResponseUtil } from '../../../shared/utils/response-util';
import { EnvironmentConfiguration } from 'app/environment/services/environment.configuration';

@Injectable()
export class AttachmentHttpService {
  private eventsUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AuthHttp,
              private environment: EnvironmentConfiguration) {
  }

  getForEvent(eventId: number): Observable<List<Attachment>> {
    return this.http.get(`${this.eventsUrl}/${eventId}/attachments`)
      .map((res: Response) => res.json())
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  add(eventId: number, file: File): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.eventsUrl}/${eventId}/attachments`, formData)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }

  get(uniqueId: string): Observable<string> {
    return this.http.get(`${this.eventsUrl}/attachments/${uniqueId}`)
      .map(resp => resp.text()).catch(ResponseUtil.unwrapErrorMessage).share();
  }

  delete(uniqueId: string): Observable<any> {
    return this.http.delete(`${this.eventsUrl}/attachments/${uniqueId}`)
      .catch(ResponseUtil.unwrapErrorMessage).share();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/attachment/attachment.http.service.ts